import React from "react";
import { getStatusColor } from "../../util/status-formatter";

interface StatusBadgeProps {
  value: string;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  value,
  className,
}) => {
  return (
    <div
      className={`px-3 py-1 max-w-[85px] rounded-md text-center text-xs font-medium capitalize ${
        className || ""
      }`}
      style={{
        color: getStatusColor(value, "text"),
        backgroundColor: getStatusColor(value, "bg"),
      }}
    >
      {value}
    </div>
  );
};
